import {
  Box,
  Button,
  Card,
  TextField,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useParams } from "react-router-dom";
import { AuthContext } from "../../../../context/AuthContext";
import { useContext, useEffect, useState } from "react";
import Panel from "./Panel";
import TrimAndFlashing from "./TrimAndFlashing";
import BenchWork from "./BenchWork";
import CopingCap from "./CopingCap";
import Cleat from "./Cleat";
import SplicePlate from "./SplicePlate";
import Accessory from "./Accessory";
import WorkOrderButton from "../../../../components/PdfButtons/WorkOrderButton";
import OrderTitle from "../../../../components/OrderTitle";
import useShopNotes from "../../../../hooks/useShopNotes";
import FlatSheet from "./FlatSheet";
import Coil from "./Coil";
import MaterialSummary from "../../../admin/Quotes/Quote/QuoteDetails/MaterialSummary";
import ShopCompletionStatusDialog from "../../../admin/Quotes/Quote/QuoteDetails/ShopCompletionStatusDialog";
import RFPDialog from "../../../admin/Quotes/Quote/QuoteDetails/RFPDialog";
import JobSchedule from "../../../admin/Quotes/Quote/QuoteDetails/JobSchedule";
import LaborSummary from "../../../admin/Quotes/Quote/QuoteDetails/LaborSummary";

import dayjs from "dayjs";
import utc from "dayjs/plugin/utc"; // ES 2015
import timezone from "dayjs/plugin/timezone"; // ES 2015
import isoWeek from "dayjs/plugin/isoWeek"; // ES 2015
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isoWeek);
const DEFAULT_TIMEZONE = "America/Phoenix";
dayjs.tz.setDefault(DEFAULT_TIMEZONE);

// Similar to Admin QuotePreview
const ShopOrderPreview = () => {
  const { id } = useParams();
  const { authToken, ezorder, decoded } = useContext(AuthContext);
  const [order, setOrder] = useState(null);
  const [productMap, setProductMap] = useState(new Map());
  const [refreshing, setRefreshing] = useState(false);
  const { shopNotes, addShopNote, isLoadingNotes } = useShopNotes(
    authToken,
    id,
    false
  );
  const [loading, setLoading] = useState(false);
  const [shopCompletionStatusDialogOpen, setShopCompletionStatusDialogOpen] =
    useState(false);
  const [rfpDialogOpen, setRfpDialogOpen] = useState(false);
  const [shopLogs, setShopLogs] = useState([]);

  const controller = new AbortController();
  const getOrderById = async (id, controller) => {
    try {
      console.log("GET ORDER BY ID");
      setRefreshing(true);
      let data = {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      };

      if (controller) {
        data.signal = controller.signal;
      }

      console.log("Get Order By ID", id);
      const response = await ezorder.get(`/shop/orders/${id}`, data);
      //console.log(response.data.order);
      let orderDetails = response.data.order;
      setOrder(response.data.order);

      const prodMap = new Map();
      for (let i = 0; i < orderDetails.items.length; i++) {
        let orderItem = orderDetails.items[i];
        prodMap.set(`${orderItem.objectType}`, orderItem);
      }
      setProductMap(prodMap);
      console.log("PRODUCT MAP", prodMap);
    } catch (error) {
      console.log("ERRORRRRR");
      console.log(error);
    } finally {
      setRefreshing(false);
    }
  };

  const getShopLogs = async () => {
    try {
      setLoading(true);
      let data = {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      };

      const response = await ezorder.get(`/shop/orders/${id}/shop-logs`, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });

      if (response.status == 200 || response.status == 201) {
        setShopLogs(response.data.shopLogs);
      } else {
        // openSnackMessage("error", response.response.data.error);
      }

      // setSalesRep(salesRep);
    } catch (error) {
      console.log(error);
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        // openSnackMessage("error", error.response.data.error);
      } else {
        // Something went really bad
        console.log(error);
        // openSnackMessage("error", error);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // const controller = new AbortController();
    if (id && authToken) {
      getOrderById(id, controller);
      getShopLogs();
    }

    return () => {
      controller.abort(); // abort api call on unmount for cleanup
    };
  }, [id, authToken]);

  if (order)
    return (
      <Box sx={{ padding: "16px" }}>
        <OrderTitle order={order} includeStatus={false} />

        {/* Actions */}
        <Box sx={{}}>
          <Typography variant="h6">Shop</Typography>
          <Button
            variant="outlined"
            sx={{ marginRight: "8px" }}
            onClick={() => {
              setShopCompletionStatusDialogOpen(true);
            }}
          >
            Update Status
          </Button>
          {decoded.role === "EZORDER_FOREMAN" && (
            <Button
              variant="outlined"
              sx={{ marginRight: "8px" }}
              onClick={() => {
                setRfpDialogOpen(true);
              }}
            >
              RFP
            </Button>
          )}
        </Box>
        <ShopCompletionStatusDialog
          orderId={order.id}
          allowCompleteAll={decoded.role === "EZORDER_FOREMAN"}
          open={shopCompletionStatusDialogOpen}
          onClose={() => {
            setShopCompletionStatusDialogOpen(false);
          }}
          onSuccess={() => {
            setShopCompletionStatusDialogOpen(false);
            getOrderById(); // reload quote
            getShopLogs(); // reload shop logs
          }}
        />
        <RFPDialog
          orderId={order.id}
          open={rfpDialogOpen}
          onClose={() => {
            setRfpDialogOpen(false);
          }}
          onSuccess={() => {
            setRfpDialogOpen(false);
            getOrderById(); // reload quote
            getShopLogs(); // reload shop logs
          }}
        />

        <Box sx={{ marginTop: "16px" }}>
          <Box sx={{ display: "flex" }}>
            <Typography variant="h6" sx={{ marginRight: "8px" }}>
              Job Schedule
            </Typography>
          </Box>
          {/* <JobDetails jobId={quote.id} /> */}
          <JobSchedule orderId={id} />
        </Box>

        <Typography variant="h5" sx={{ marginTop: "32px" }}>
          Details
        </Typography>
        <Box>
          {order.orderStatus && // has Status Approved and beyond (include cancelled?)
            order.orderStatus.name !== "SAVED" &&
            order.orderStatus.name !== "QUOTE_REQUESTED" &&
            order.orderStatus.name !== "ESTIMATE_APPROVAL_NEEDED" && (
              <WorkOrderButton
                orderId={order.id}
                variant="outlined"
                color="success"
                sx={{ marginRight: "8px" }}
              />
            )}
        </Box>
        <Card sx={{ marginTop: "8px", padding: "16px" }}>
          <Box sx={{ display: "flex", flexDirection: "column", gap: "2rem" }}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
              <TextField
                label="PO #"
                value={order.poNumber}
                InputProps={{
                  readOnly: true, // This makes the input read-only
                }}
              />
              <TextField
                size="small"
                label="Notes"
                multiline
                maxRows={3}
                value={order.quoteNotes}
                InputProps={{
                  readOnly: true, // This makes the input read-only
                }}
              />
            </Box>
            <Box sx={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
              {order.isCustomMaterial ? (
                <TextField
                  size="small"
                  label="Custom Material"
                  value={order.customColor}
                  InputProps={{
                    readOnly: true, // This makes the input read-only
                  }}
                />
              ) : (
                <>
                  <TextField
                    size="small"
                    label="Color"
                    value={`${order.color} - ${order.manufacturer}`}
                    InputProps={{
                      readOnly: true, // This makes the input read-only
                    }}
                  />
                  <TextField
                    size="small"
                    label="Gauge"
                    value={order.gauge}
                    InputProps={{
                      readOnly: true, // This makes the input read-only
                    }}
                  />
                </>
              )}
            </Box>
          </Box>
        </Card>

        <Box>
          {productMap.get("FlatSheet") && (
            <FlatSheet
              flatSheet={productMap.get("FlatSheet")}
              sx={{ marginTop: "32px" }}
            />
          )}
          {productMap.get("Coil") && (
            <Coil coil={productMap.get("Coil")} sx={{ marginTop: "32px" }} />
          )}

          {productMap.get("Panel") && (
            <Panel panel={productMap.get("Panel")} sx={{ marginTop: "32px" }} />
          )}
          {productMap.get("TrimAndFlashing") && (
            <TrimAndFlashing
              flatSheetSize={order.flatSheetSize}
              trim={productMap.get("TrimAndFlashing")}
              style={{ marginTop: "32px" }}
            />
          )}
          {productMap.get("BenchWork") && (
            <BenchWork
              benchWork={productMap.get("BenchWork")}
              style={{ marginTop: "32px" }}
            />
          )}
          {productMap.get("CopingCap") && (
            <CopingCap
              flatSheetSize={order.flatSheetSize}
              copingCap={productMap.get("CopingCap")}
              style={{ marginTop: "32px" }}
            />
          )}
          {productMap.get("CopingCapCleat") && (
            <Cleat
              flatSheetSize={order.flatSheetSize}
              cleat={productMap.get("CopingCapCleat")}
              style={{ marginTop: "32px" }}
            />
          )}
          {productMap.get("SplicePlate") && (
            <SplicePlate
              splicePlate={productMap.get("SplicePlate")}
              style={{ marginTop: "32px" }}
            />
          )}
          {productMap.get("Accessory") && (
            <Accessory
              accessory={productMap.get("Accessory")}
              style={{ marginTop: "32px", marginBottom: "32px" }}
            />
          )}
        </Box>
        <MaterialSummary order={order} style={{ marginTop: "32px" }} />
        <Box sx={{ marginTop: "32px" }}>
          <LaborSummary order={order} />
        </Box>
        <Box sx={{ marginTop: "16px" }}>
          <Typography variant="h6">Logs</Typography>
          <TableContainer component={Box}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Date</TableCell>
                  <TableCell>Type</TableCell>
                  <TableCell>User</TableCell>
                  <TableCell>Details</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {shopLogs &&
                  shopLogs.map((shopLog, index) => (
                    <TableRow key={shopLog.id}>
                      <TableCell>
                        {dayjs(shopLog.createdAt)
                          .tz("America/Phoenix")
                          .format("MM/DD/YY")}
                      </TableCell>
                      <TableCell>{shopLog.logType}</TableCell>
                      <TableCell>{shopLog.user.fullName}</TableCell>
                      <TableCell>{shopLog.text}</TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Box>
    );
};

export default ShopOrderPreview;
